import React from "react";
import { Routes, Route } from "react-router-dom";
import ListBlog from "../Components/Blog/listBlog";
import AddBlogPage from "../Components/Blog/addBlog";
import EditBlogPage from "../Components/Blog/editBlog";
import ViewBlogPage from "../Components/Blog/viewBlog";

const BlogRoutes = () => {
  return (
    <Routes>
      <Route path="/blog" element={<ListBlog></ListBlog>}></Route>
      <Route path="/blog/add" element={<AddBlogPage></AddBlogPage>}></Route>
      <Route path="/blog/edit/:id" element={<EditBlogPage></EditBlogPage>}></Route>
      <Route
        path="/blog/view/:id"
        element={<ViewBlogPage></ViewBlogPage>}
      ></Route>
    </Routes>
  );
};

export default BlogRoutes;
